import PolicyIcon from '@mui/icons-material/Policy';
import PrivacyTipIcon from '@mui/icons-material/PrivacyTip';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import {
	Box,
	Button,
	Dialog,
	DialogContent,
	DialogTitle,
	Grid,
	Stack,
	Typography,
	TypographyProps,
} from '@mui/material';
import { AuthnCodeField, ModalBox } from 'components';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAPI, useBizLogicActions } from 'stores';

const AuthStatusBarTypo = ({ children }: TypographyProps) => {
	return (
		<Typography variant="body1" color="authStatusBar.text">
			{children}
		</Typography>
	);
};

const AuthStatusBar = (props: any) => {
	const navigate = useNavigate();
	const { t, i18n } = useTranslation();
	console.log(i18n.resolvedLanguage);
	const [openCodeInput, setOpenCodeInput] = useState(false);
	const [openGiftModal, setOpenGiftModal] = useState(false);
	const { handleSubmit, control, setValue, setError, reset } = useForm();
	const { authenticateUAID } = useAPI();
	const { handleQueryResponse, getGiftMode } = useBizLogicActions();

	let status = props.status;
	let uaidType = props.uaidType;
	let authenticationId = props.authenticationId;
	let challengeCode = props.challengeCode;
	let currentUAID = props.currentReqUAID;
	let verifyStatus = props.verifyStatus;
	const verifyCode = props.verifyCode;
	const productName = props.productName;
	const giftMode = getGiftMode();

	//	When code need further authentication with required code (authn code / gift code) proceed with 1
	//	Other cases proceed with 0 to scan another code.
	const proceedMode =
		uaidType === 5 || verifyCode?.includes('wait_gift_code') ? 1 : 0;

	console.log('verifyStatus->' + verifyStatus);
	/*
	let checkT = t('product.dialog.check');

	const inputRule = {
		required: '6 characters code required',
		pattern: {
			value: /^[\w]{6}$/,
			message: checkT,
		},
	};*/

	const handleScan = () => {
		navigate('/Scan', { replace: true });
	};
	const handleGift = () => {
		setOpenGiftModal(true);
	};
	const handleGiftConfirm = async () => {
		navigate('/Gift', { replace: true, state: { id: authenticationId } });
	};

	const handleCloseCodeInput = () => {
		setOpenCodeInput(false);
		reset();
	};

	const openKeyInCode = () => {
		setOpenCodeInput(true);
	};

	const onSubmit = (data: any) => {
		let code = data.inputCode;
		console.log(code);

		let authenticatedResult = authenticateUAID(
			currentUAID,
			null,
			authenticationId,
			challengeCode,
			code,
			false
		);

		authenticatedResult.then((response) => {
			console.log('authentication code --> ');
			console.log(response);

			if (response.code === '0') {
				if (
					[
						'msg_code_successful',
						'msg_code_AxRQR_ok_successful',
						'msg_code_receive_gift_successful',
					].indexOf(response.data.authenticationMessage.code) !== -1
				) {
					handleQueryResponse(response);
					setValue('inputCode', '');
					setOpenCodeInput(false);
				} else {
					//let message = t('product.dialog.err');
					let message = JSON.parse(
						response.data.authenticationMessage.message[
							i18n.resolvedLanguage
						]
					)['content'];
					setError('inputCode', {
						//message: 'The provided code is invalid.',
						message: message,
					});
				}
			} else {
				let message =
					response.code + response.message[i18n.resolvedLanguage];
				setValue('inputCode', '');
				setError('inputCode', {
					message: message,
				});
			}
		});
	};

	return (
		<>
			<Box pt={1} pl={2} pr={2}>
				{status === 'success' &&
				[3, 4].indexOf(verifyStatus) !== -1 &&
				giftMode ? (
					<Button
						variant="contained"
						sx={{
							minWidth: '100%',
							backgroundColor: 'authStatusBar.main',
						}}
						onClick={handleGift}
					>
						<AuthStatusBarTypo>
							{/*Send Gift*/}
							{t('verify.sendGift')}
						</AuthStatusBarTypo>
					</Button>
				) : verifyCode === 'msg_code_recalled_fail' ? (
					<Button
						variant="contained"
						sx={{
							minWidth: '100%',
							backgroundColor: 'authStatusBar.main',
						}}
						// startIcon={<VerifiedUserIcon />}
						onClick={handleScan}
					>
						<AuthStatusBarTypo>
							{/*Proceed for recalled code*/}
							{t('verify.proceed')}
						</AuthStatusBarTypo>
					</Button>
				) : status === 'success' && verifyStatus !== 4 ? (
					<Button
						variant="contained"
						sx={{
							minWidth: '100%',
							backgroundColor: 'authStatusBar.success',
						}}
						startIcon={<VerifiedUserIcon />}
						onClick={handleScan}
					>
						<AuthStatusBarTypo>
							{/*Product Authenticated*/}
							{t('verify.success')}
						</AuthStatusBarTypo>
					</Button>
				) : status === 'success' && verifyStatus === 4 ? (
					<Button
						variant="contained"
						sx={{
							minWidth: '100%',
							backgroundColor: 'authStatusBar.main',
						}}
						startIcon={<PolicyIcon />}
						onClick={handleScan}
					>
						<AuthStatusBarTypo>
							{/*Product Authenticated Previously*/}
							{t('verify.repeatVerify')}
						</AuthStatusBarTypo>
					</Button>
				) : status === 'verify' && proceedMode === 0 ? (
					<Button
						variant="contained"
						sx={{
							minWidth: '100%',
							backgroundColor: 'authStatusBar.main',
						}}
						startIcon={<PolicyIcon />}
						onClick={handleScan}
					>
						<AuthStatusBarTypo>
							{/*Verify Product Authenticity*/}
							{uaidType === 7 && <>{t('product.nextBtn.4')}</>}
							{uaidType !== 7 && (
								<>{t('verify.toScanHiddenCode')}</>
							)}
						</AuthStatusBarTypo>
					</Button>
				) : status === 'verify' && proceedMode === 1 ? (
					<Stack spacing={2}>
						<Button
							variant="contained"
							sx={{
								minWidth: '100%',
								display: 'flex',
								backgroundColor: 'authStatusBar.main',
							}}
							//startIcon={<PolicyIcon />}
							onClick={openKeyInCode}
						>
							<AuthStatusBarTypo>
								{t('product.nextBtn.5')}
							</AuthStatusBarTypo>
						</Button>
						<Button
							variant="contained"
							sx={{
								minWidth: '100%',
								backgroundColor: 'authStatusBar.main',
							}}
							//startIcon={<PolicyIcon />}
							onClick={handleScan}
						>
							<AuthStatusBarTypo>
								{/*Scan Another AR/QR Code*/}
								{t('product.nextBtn.4')}
							</AuthStatusBarTypo>
						</Button>
					</Stack>
				) : status === 'failed' ? (
					<Button
						variant="contained"
						sx={{
							minWidth: '100%',
							backgroundColor: 'authStatusBar.error',
						}}
						startIcon={<PrivacyTipIcon />}
						onClick={handleScan}
					>
						<AuthStatusBarTypo>
							{/*'Peoduct Verified By Others'*/}
							{t('verify.fail')}
						</AuthStatusBarTypo>
					</Button>
				) : (
					<Button
						variant="contained"
						sx={{
							minWidth: '100%',
							backgroundColor: 'authStatusBar.main',
						}}
						//startIcon={<PrivacyTipIcon />}
						onClick={handleScan}
					>
						<AuthStatusBarTypo>
							{t('product.auth')}
						</AuthStatusBarTypo>
					</Button>
				)}
			</Box>
			<Dialog
				open={openCodeInput}
				onClose={handleCloseCodeInput}
				aria-describedby="alert-dialog-slide-description"
			>
				<DialogTitle>
					{verifyCode?.includes('wait_gift_code')
						? t('product.dialog.gift')
						: t('product.dialog.title')}
				</DialogTitle>
				<DialogContent>
					<Box
						component="form"
						autoComplete="off"
						onSubmit={handleSubmit(onSubmit)}
					>
						<AuthnCodeField control={control} />
						<Grid
							container
							spacing={8}
							style={{ paddingTop: '5%' }}
						>
							<Grid item xs={6}>
								<Button
									disableRipple
									fullWidth
									variant="contained"
									onClick={handleCloseCodeInput}
									sx={{
										borderRadius: '12px',
										fontSize: '0.8em',
										height: '100%',
										backgroundColor: '#C8D3E6',
									}}
								>
									{t('product.dialog.cancel')}
								</Button>
							</Grid>
							<Grid item xs={6}>
								<Button
									disableRipple
									fullWidth
									variant="contained"
									//size="large"
									type="submit"
									sx={{
										borderRadius: '12px',
										fontSize: '0.8em',
										height: '100%',
									}}
								>
									{t('product.dialog.submit')}
								</Button>
							</Grid>
						</Grid>
					</Box>
				</DialogContent>
			</Dialog>
			<ModalBox
				open={openGiftModal}
				onClose={() => {
					setOpenGiftModal(false);
				}}
				onCancel={() => {
					setOpenGiftModal(false);
				}}
				onSubmit={() => {
					handleGiftConfirm().then();
				}}
			>
				<Grid
					container
					item
					direction="column"
					alignItems="center"
					spacing={2}
				>
					<Grid item xs={12}>
						<Typography variant={'subtitle2'}>
							{t('verify.confirm.gift')}
						</Typography>
					</Grid>
					<Grid item xs={12}>
						<Typography variant={'caption'}>
							{`${t('verify.query.gift')}${productName}${t(
								'default.question.mark'
							)}`}
						</Typography>
					</Grid>
				</Grid>
			</ModalBox>
		</>
	);
};

export default AuthStatusBar;
